import {
    FETCH_LOGIN_REQUEST,
    FETCH_LOGIN_SUCCESS,
    INTIALIZE_TOKEN,
    REMOVE_TOKEN,
    FETCH_Lang_REQUEST,
    ACCOUNT_NOT_VERIFIED,
    FETCH_UPDATE_REQUEST,
    CLOSE_MENU,
    CLOSE_MENU_MOBILE,
    FETCH_ACTIVE_STUDENT_SUCCESS,
    SET_USER_TYPE
} from "../type";

import axios from "axios";
import { API_ENDPOINT } from '../../../AppConfig';
import { hideLoading, showLoading } from 'react-redux-loading-bar';
import { showSnack } from 'react-redux-snackbar';

export function LoginRequest(data, lang) {
    return (dispatch, getState) => {
        dispatch({ type: FETCH_LOGIN_REQUEST });
        dispatch(showLoading());
        let uri = `${API_ENDPOINT}/signin`;
        axios.post(uri, data, {
            headers: {
                'Accept-Language': lang
            }
        })
            .then(response => {
                console.log("response Login", response.data, response.data.user.type, response.data.user.student, JSON.stringify(response.data.user).user)
                saveToLocalStorage('Korasatoken', JSON.stringify(response.data.token));
                saveToLocalStorage('KorasaAppuser', JSON.stringify(response.data.user));
                saveToLocalStorage('id', JSON.stringify(response.data.user.id));
                saveToLocalStorage('KorasauserType', JSON.stringify(response.data.user.type));
                saveToLocalStorage('Language', response.data.user.language);
                if (response.data.user.type === 'GUARDIAN' && response.data.user.student.length > 0) {
                    saveToLocalStorage('KorasauserActivestudent', JSON.stringify(response.data.user.student[0]))
                }
                dispatch({ type: FETCH_Lang_REQUEST, payload: response.data.user.language });
                dispatch({ type: FETCH_LOGIN_SUCCESS, payload: response.data });
                dispatch(hideLoading());
                console.log("DataofLogin:", response.data.user.type, JSON.stringify(response.data.user.type))
            }).catch(error => {
                console.log("Error Login", error.response)
                if (!error.response) {
                    dispatch(hideLoading());
                    dispatch(showSnack('myUniqueId', {
                        label: lang === 'en' ? 'Network Error' : 'خطأ فى الاتصال بالانترنت',
                        timeout: 7000,
                        button: { label: lang === 'en' ? 'LogIn' : ' تسجيل الدخول' }
                    }));
                } else if (error.response.status === 400) {
                    let obj = {
                        email: data.email,
                        type: data.type
                    }
                    saveToLocalStorage('sendEmail', JSON.stringify(obj));
                    dispatch({ type: ACCOUNT_NOT_VERIFIED });
                    dispatch(hideLoading());
                    dispatch(showSnack('myUniqueId', {
                        label: error.response.data.errors,
                        timeout: 7000,
                        button: { label: lang === 'en' ? 'LogIn' : ' تسجيل الدخول' }
                    }));
                } else {
                    dispatch(hideLoading());
                    dispatch(showSnack('myUniqueId', {
                        label: error.response.data.errors,
                        timeout: 7000,
                        button: { label: lang === 'en' ? 'LogIn' : ' تسجيل الدخول' }
                    }));
                }
            })
    }
}
export function UpdateUser(data, lang, token) {
    return (dispatch, getState) => {
        dispatch(showLoading());
        let uri = `${API_ENDPOINT}/user/updateInfo`;
        axios.post(uri, data, {
            headers: {
                Authorization: `Bearer ${token}`,
                'Accept-Language': lang
            }
        })
            .then(response => {
                console.log("UPDATE Login", response.data)
                dispatch({ type: FETCH_UPDATE_REQUEST, payload: response.data });
            }).catch(err => console.log("UPDATE err", err.response))

    }
}
export function visit(type, sublevelID) {
    return (dispatch, getState) => {
        dispatch(showLoading())
        saveToLocalStorage('KorasauserType', JSON.stringify(type));
        saveToLocalStorage('VisitorsublevelID', sublevelID)
        saveToLocalStorage('KorasaAppuser', '');
        saveToLocalStorage('id', '');
        saveToLocalStorage('Language', 'ar');
        dispatch({ type: SET_USER_TYPE , payload: type});
    };
}

export function IntializeToken(token, type, user, lang) {
    console.log("test initialize  after is: ", user)
    return (dispatch, getState) => {
        dispatch({
            type: INTIALIZE_TOKEN, tokenPayload: JSON.parse(token), userPayload: user,
            typePayload: JSON.parse(type),
            activeStudentPayload: user.type === 'GUARDIAN' && JSON.parse(localStorage.getItem('KorasauserActivestudent'))
        });
        dispatch({ type: FETCH_Lang_REQUEST, payload: lang });

    }
}
export function activateStudent(student) {
    console.log("Active Student in new function", student)

    return (dispatch, getState) => {
        saveToLocalStorage('KorasauserActivestudent', JSON.stringify(student))
        dispatch({ type: FETCH_ACTIVE_STUDENT_SUCCESS, payload: student });

    }
}
export function saveToLocalStorage(key, value) {
    localStorage.setItem(key, value);
}
export function sendLogout() {
    console.log("LOGDOUUUUT")
    saveToLocalStorage('KorasauserType', '');
    saveToLocalStorage('Korasatoken', '');
    // saveToLocalStorage('KorasaAppuser', '')
    saveToLocalStorage('id', '');
    saveToLocalStorage('VisitorsublevelID', '')
    // saveToLocalStorage('KorasauserActivestudent', '')
    localStorage.removeItem('KorasauserActivestudent');
    localStorage.removeItem('KorasaAppuser');
    // saveToLocalStorage('KorasauserType','');
    return (dispatch, getState) => {
        dispatch({ type: REMOVE_TOKEN });
    }
}

export function closeMenu(closemenu) {
    return (dispatch, getState) => {
        console.log("test menu is: ", closemenu)
        dispatch({ type: CLOSE_MENU, payload: closemenu });
    }
}
export function closeMenuMobile(closemenu) {
    return (dispatch, getState) => {
        console.log("test menu is: ", closemenu)
        dispatch({ type: CLOSE_MENU_MOBILE, payload: closemenu });
    }
}